import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  activeTeam: {},
  isOwner: false,
};

const teamUiSlice = createSlice({
  name: "teamUi",
  initialState,
  reducers: {
    setActiveTeam: (state, action: PayloadAction<string>) => {
      state.activeTeam = action.payload;
    },
    setIsOwner: (state, action: PayloadAction<boolean>) => {
      state.isOwner = action.payload;
    },
  },
});

export const { setActiveTeam, setIsOwner } = teamUiSlice.actions;
export default teamUiSlice.reducer;
